/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import iconProfile from '../assets/icon/icon-profile-circle.svg';
import iconSun from '../assets/icon/icon-sun.svg';
import iconMoon from '../assets/icon/icon-moon.svg';
import Icon from './Icon';
import ProfileMenu from './ProfileMenu';
import menuList from '../helpers/menuList';
import { setDarkMode } from '../configs/redux/reducer/ui';
import { useAppSelector, useAppDispatch } from '../hooks/useAppReducer';
import { getTheme } from '../helpers/theme';

const HeaderWrapper = styled.header`
    position: fixed;
    display: block;
    width: 100%;
    max-width: calc(100% - 20%);
    padding: 0;
    height: 60px;
    background: var(--color-white);
    border-bottom: 1px solid var(--color-white);
    transition: max-width .2s ease;
    top: 0;
    right: 0;
    z-index: 98;
    color: var(--color-base-text-light);

    &.drawer-minimize {
        max-width: calc(100% - 7%);
    }

    @media only screen and (max-width: 768px) {
        max-width: 100% !important;
    }
`;

const HeaderItemWrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    overflow: hidden;
`;

const HeaderItem = styled.div<{ alignRight?: boolean }>`
    position: relative;
    display: block;
    width: 90%;
    ${(props) => (props.alignRight ? 'text-align: right;' : '')}
    @media only screen and (max-width: 768px) {
        &:nth-of-type(1) {
            width: 20%;
        }
        &:nth-of-type(2) {
            width: 80%;
        }
    }
`;

const ActiveMenu = styled.div<{darkMode?: boolean}>`
    position: relative;
    display: block;
    width: 100%;
    padding: 0;

    img {
        filter: grayscale(100%) ${(props) => (props.darkMode ? 'brightness(0) invert(1)' : '')};
        opacity: 40%;
    }

    span {
        position: relative;
        display: inline-block;
        font-weight: var(--font-bold);
        margin-left: .5rem;
        vertical-align: middle;
    }

    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

const ProfileWrapper = styled.div<{darkMode?: boolean}>`
    position: relative;
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;

    img {
        filter: ${(props) => (props.darkMode ? 'brightness(0) invert(1)' : 'none')};
    }
`;

const MobileDrawerToggle = styled.div`
    position: relative;
    display: none;
    width: auto;
    height: auto;
    cursor: pointer;

    @media only screen and (max-width: 768px) {
        display: block;
    }
`;

interface IHeader {
    activeMenu?: string
}

const Header = (props: IHeader) => {
    const { activeMenu } = props;
    const dispatch = useAppDispatch();
    const [breadcrumbActiveMenu, setBreadcrumbActiveMenu] = useState<any>({});
    const [showProfile, setShowProfile] = useState(false);
    const [isDark, setIsDark] = useState(false);
    const { name, company_name, role_name } = useAppSelector((state: any) => state.userReducer.profile);

    const setDark = () => {
        dispatch(setDarkMode(true));
        localStorage.setItem('theme', 'dark');
        document.documentElement.setAttribute('data-theme', 'dark');
    };

    const setLight = () => {
        dispatch(setDarkMode(false));
        localStorage.setItem('theme', 'light');
        document.documentElement.setAttribute('data-theme', 'light');
    };

    const handleTheme = () => {
        setIsDark(!isDark);
        if (isDark) {
            setLight();
        } else {
            setDark();
        }
    };

    const showDrawer = () => {
        const drawer = document.getElementById('nav-drawer');
        drawer?.classList.add('visible');
    };

    useEffect(() => {
        let temp = {};
        menuList.forEach((item:any) => {
            if (item.roles) {
                if (item.roles[0] === role_name && item.tag === activeMenu) {
                    temp = item;
                }
            } else if (item.tag === activeMenu) {
                temp = item;
            }
        });
        setBreadcrumbActiveMenu(temp);
    }, []);

    useEffect(() => {
        const defaultLight = getTheme();
        setIsDark(defaultLight);
        if (defaultLight) {
            setDark();
        }
    }, []);

    return (
        <>
            <HeaderWrapper id="header">
                <HeaderItemWrapper>
                    <HeaderItem>
                        <MobileDrawerToggle onClick={() => showDrawer()}>
                            <Icon icon="menu" />
                        </MobileDrawerToggle>
                        {activeMenu && (
                            <ActiveMenu darkMode={isDark}>
                                <Icon custom icon={breadcrumbActiveMenu.icon} />
                                <span>{breadcrumbActiveMenu.title}</span>
                            </ActiveMenu>
                        )}
                    </HeaderItem>
                    <HeaderItem alignRight>
                        <div className="row justify-content-end align-items-center">
                            <div className="col-2">
                                <div className="cursor-pointer" onClick={handleTheme}>
                                    <Icon custom icon={isDark ? iconSun : iconMoon} />
                                </div>
                            </div>
                            <div className="col-7">
                                <div className="row">
                                    <div className="col-12">
                                        <p className="p-0 m-0 text-start font-bold text-nowrap text-truncate">{company_name}</p>
                                    </div>
                                    <div className="col-12">
                                        <p className="p-0 m-0 text-start font-small text-nowrap text-capitalize text-truncate">{`${name} - ${role_name.toLowerCase()}`}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-2">
                                <ProfileWrapper darkMode={isDark} onClick={() => setShowProfile(!showProfile)}>
                                    <Icon custom icon={iconProfile} />
                                    <Icon icon="chevron-down" white={isDark} />
                                </ProfileWrapper>
                            </div>
                        </div>
                    </HeaderItem>
                </HeaderItemWrapper>
            </HeaderWrapper>
            <ProfileMenu visible={showProfile} onProfileClose={(showProfileMenu: boolean) => setShowProfile(showProfileMenu)} />
        </>
    );
};

Header.defaultProps = {
    activeMenu: ''
};

export default Header;
